import { Shield, CheckCircle, Users, Award } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Shield,
      title: 'Trusted Reviews',
      description: 'Every casino we feature undergoes rigorous testing. We play, we verify, we recommend only the best.',
    },
    {
      icon: CheckCircle,
      title: 'Verified Bonuses',
      description: 'No hidden terms, no surprises. Every bonus is tested and confirmed before we share it with you.',
    },
    {
      icon: Users,
      title: 'Player-Focused',
      description: 'We put players first. Our reviews highlight what matters: payouts, games, and real experiences.',
    },
    {
      icon: Award,
      title: 'Expert Insights',
      description: 'Years of industry knowledge distilled into clear, actionable advice for UK players.',
    },
  ];

  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div 
              className="w-full h-96 rounded-lg bg-cover bg-center"
              style={{ backgroundImage: 'url(/images/ayush-kumar-5to5BOIwLPw-unsplash.webp)' }}
            ></div>
          </div>
          
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-dark mb-6">
              Why Sceptre Slots?
            </h2>
            <p className="text-lg text-gray-light mb-8 leading-relaxed" itemprop="description">
              We're not just another review site. We're your personal casino consultants, 
              dedicated to finding you the perfect match. With thousands of hours spent 
              testing platforms, verifying bonuses, and tracking payout speeds, we've 
              built a reputation for honest, thorough reviews that UK players can trust.
            </p>
            <p className="text-lg text-gray-light mb-8 leading-relaxed" itemprop="description">
              Our mission is simple: help you play smarter, win more, and enjoy every 
              moment. Whether you're chasing jackpots or prefer casual spins, we've got 
              the insights you need to make informed decisions.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mt-8">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index} className="bg-gray-50 p-4 rounded-lg">
                    <Icon className="text-yellow-accent mb-3" size={24} />
                    <h3 className="font-bold text-gray-dark mb-2">{feature.title}</h3>
                    <p className="text-sm text-gray-light">{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

